import { render, staticRenderFns } from "./SettingPage.vue?vue&type=template&id=89c60c0a&scoped=true&"
import script from "./SettingPage.vue?vue&type=script&lang=js&"
export * from "./SettingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c60c0a",
  null
  
)

export default component.exports